<template>
    <div>
        <div class="d-flex py-2 px-3 justify-content-between align-items-center"
            style="margin: -3px 0 0 0;  border-bottom: 1px solid #93a8d6;">
            <div class="form-group mb-0" id="tab_list">
                <ul class="nav nav-pills" role="tablist" id="tabs" style="font-size: 14px; font-weight: 500">
                    <li class="nav-item type1 mr-4">
                        <a class=" nav-link  px-4" v-bind:class="[selectTab == 'all' ? 'active' : '']"
                            href="javascript:void(0);" v-on:click="selectedStatus('all')"
                            @click="notificationStatus('all')">All</a>
                    </li>
                    <li class="nav-item type1 mr-4">
                        <a class="nav-link " v-bind:class="[selectTab == '0' ? 'active' : '']" href="javascript:void(0);"
                            v-on:click="selectedStatus('0')" @click="notificationStatus('0')">Email</a>
                    </li>
                    <li class="nav-item type2 mr-4">
                        <a class="nav-link " v-bind:class="[selectTab == '1' ? 'active' : '']" href="javascript:void(0);"
                            v-on:click="selectedStatus('1')" @click="notificationStatus('1')">Notification</a>
                    </li>
                    <li class="nav-item type3 mr-4">
                        <a class="nav-link " v-bind:class="[selectTab == '2' ? 'active' : '']" href="javascript:void(0);"
                            v-on:click="selectedStatus('2')" @click="notificationStatus('2')">Email & Notification</a>
                    </li>

                </ul>
            </div>
            <div class="d-flex align-items-center" style="margin-top: 6px; gap: 8px;" id="support_filter">
                <div class="has-search"  v-if="$can('all_notifications_search')"> 
                    <span class="fa fa-search form-control-feedback"></span>
                    <input v-model="search" @keyup="notificaitonSearch" type="text" class="form-control search-input" placeholder="Search Here..." />
                </div>
                <router-link  v-if="$can('all_notifications_create') && $route.path == '/notifications'" to="/notifications/new" class="btn action-btn">
                    <span class="fa fa-plus" style="font-size:20px; color:#48a6a6"></span>
                </router-link>
            </div>
        </div>

    </div>
</template>
<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import $ from 'jquery';
import VueSkeletonLoader from 'skeleton-loader-vue';
import { localeData } from 'moment';
export default {
    name: 'ticket_filter',
    components: {
        Multiselect, VueSkeletonLoader
    },

    props: [],
    data() {
        return {
            selectTab: 'all',
            search: "",
            organizations: [],
            reset: false,
            skeletonLoader: false,

        }
    },
    mounted: function () {
    },
    

    methods: {
        selectedStatus(event) {
            this.$emit("selectedNotificationTab", event);
        },
        notificationStatus(event) {

            this.selectTab = event;
            this.skeletonLoader = true;
            // localStorage.setItem("notificationStatus",this.selectTab);
            this.$emit("skeletonLoader", this.skeletonLoader);
            this.$store.dispatch("users/getAllnotifications", [1, this.selectTab, this.search]).then(() => {
                if (this.$route.query.page != 1) {
                    this.$router.push("notifications?page=" + 1);
                }
                this.skeletonLoader = false;
                this.$emit("skeletonLoader", this.skeletonLoader);
            });
        },
        showFilter() {
            this.show_filter == 'show' ? localStorage.setItem('show_filter', false) : localStorage.setItem('show_filter', 'show');
        },
        notificaitonSearch() {
            if (this.search.replace(/\s/g, "").length || this.search == '') {
                this.skeletonLoader = true;
                this.$emit("skeletonLoader", this.skeletonLoader);
                this.$store.dispatch("users/getAllnotifications", [1, this.selectTab, this.search]).then(() => {
                    this.skeletonLoader = false;
                    this.$emit("skeletonLoader", this.skeletonLoader);
                });
            }
        }
    }
}

</script>

<style scoped lang="scss">
.has-search .form-control {
    height: calc(1.3em + 0.75rem + 2px);
}

select[class="form-control"] {
    height: calc(1.8em + 0.75rem + 2px) !important;
}

.dropdown-item {
    cursor: pointer;
}

#tabs .nav-link {
    background: transparent;
    color: rgb(66, 64, 64);
}

#tabs .active {
    background-color: #48a6a6 !important;
    color: white;
}
.action-btn{
    background-color: #f6f6f6;
    border: 1px solid #ced4da;
    color: #5c5c5c;
    padding:0.3rem 0.6rem 0.1rem;
}
.action-btn:hover{
    background-color: #48a6a6;
    border-color: #48a6a6;
}
.search-input{
    background-color: #f6f6f6;
}
.btn:hover{
    background: rgb(72, 166, 166) !important;
    >.fa-plus{
      color: white !important;
    }
    
  }
</style>